import { getApiConfig } from '../config/api';

const apiConfig = getApiConfig();

export interface AppVersionInfo {
  platform: string;
  latestVersion: string;
  minSupportedVersion: string;
  storeUrl: string;
  releaseNotes: string | null;
  isMaintenanceMode: boolean;
}

/**
 * Fetches app version info for the given platform from the backend.
 * This is a public endpoint (no auth required).
 */
export const getAppVersion = async (appName: string, platform: 'android' | 'ios'): Promise<AppVersionInfo | null> => {
  try {
    const url = `${apiConfig.BASE_URL}${apiConfig.ENDPOINTS.GET_APP_VERSION.replace(':appName', appName).replace(':platform', platform)}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      console.warn(`Failed to fetch app version for ${platform}: ${response.status}`);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.warn('Error fetching app version:', error);
    return null;
  }
};

/**
 * Sends app version info to the React Native WebView bridge.
 * Only runs when inside the mobile app (window.ReactNativeWebView exists).
 */
export const sendVersionInfoToNative = (versionInfo: AppVersionInfo): void => {
  const reactNativeWebView = (window as any).ReactNativeWebView;
  if (reactNativeWebView) {
    reactNativeWebView.postMessage(JSON.stringify({
      action: 'APP_VERSION_INFO',
      data: {
        latestVersion: versionInfo.latestVersion,
        minSupportedVersion: versionInfo.minSupportedVersion,
        storeUrl: versionInfo.storeUrl,
        releaseNotes: versionInfo.releaseNotes,
        isMaintenanceMode: versionInfo.isMaintenanceMode,
      },
    }));
  }
};
